module.exports = __webpack_public_path__ + "img/mini-013.cfd9e193.jpg";